module.exports = __webpack_public_path__ + "img/etc.9d4534ae.svg";